import * as React from 'react'
import { adminService } from '../../../../../../services'
import { toast } from 'react-toastify'
import { Button, Form, Icon, Pagination, PaginationProps, Segment, Table } from 'semantic-ui-react'
import { Modal, ModalBody, ModalHeader } from 'reactstrap'
import EditUser from './EditUser'
import { common } from '../../../../../../utils/common'

type UserManagementState = {
  isLoading: boolean,
  data: IUserSearchInfo,
  totalPage: number,
  pageData?: IPageable<IUser>,
  showEditUser?: boolean,
  userSelected?: IUser,
}

export class UserManagement extends React.Component {
  state: UserManagementState = {
    isLoading: false,
    data: {
      page: 0,
    },
    totalPage: 1,
    showEditUser: false
  }

  searchUser = (dataSearch: IUserSearchInfo) => {
    this.setState({
      isLoading: true
    })
    adminService.searchUser(dataSearch)
      .then(user => {
        this.setState({
          pageData: user,
          totalPage: user.totalPages,
          isLoading: false,
        })
      })
      .catch(error => {
        toast.error(error.message)
        this.setState({isLoading: false})
      })
  }

  onShowEditUser = (user: IUser) => {
    this.setState({
      showEditUser: true,
      userSelected: user,
    })
  }

  renderHeader = () => {
    return (
      <Table.Header>
      <Table.Row>
        <Table.HeaderCell>Username</Table.HeaderCell>
        <Table.HeaderCell>SteamId</Table.HeaderCell>
        <Table.HeaderCell>Email</Table.HeaderCell>
        <Table.HeaderCell>Ngày đăng ký</Table.HeaderCell>
        <Table.HeaderCell>Số tiền trong tài khoản</Table.HeaderCell>
        <Table.HeaderCell>Tiền đổi thưởng</Table.HeaderCell>
        <Table.HeaderCell>Active</Table.HeaderCell>
        <Table.HeaderCell>Edit</Table.HeaderCell>
      </Table.Row>
    </Table.Header>)
  }

  renderBody = (data?: IPageable<IUser>) => {
    if (!data) {
      return (<Table.Row>No User</Table.Row>)
    }
    return data.content.map(user => (
      <Table.Row>
        <Table.Cell>{user.username}</Table.Cell>
        <Table.Cell>{user.steamId}</Table.Cell>
        <Table.Cell>{user.email}</Table.Cell>
        <Table.Cell>{common.toLocaleDateTime(user.createdAt)}</Table.Cell>
        <Table.Cell>{user.amount ? user.amount.toLocaleString('vn') : '0'}</Table.Cell>
        <Table.Cell>{user.totalDep ? user.totalDep.toLocaleString('vn') : '0'}</Table.Cell>
        <Table.Cell error={!user.active}>{user.active ? 'TRUE' : 'FALSE'}</Table.Cell>
        <Table.Cell><Icon link={true} name={'edit'} onClick={() => this.onShowEditUser(user)}/></Table.Cell>
      </Table.Row>
    ))
  }

  componentDidMount() {
    this.searchUser({page: 0})
  }

  handlePageChange = (event: React.MouseEvent<HTMLAnchorElement>, data: PaginationProps) => {
    let dataRequest = this.state.data
    if (!data.activePage || data.activePage <= 0) {
      dataRequest.page = 0
    } else {
      dataRequest.page = Number(data.activePage) - 1
    }
    this.searchUser(dataRequest)
  }

  onDataChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    event.preventDefault()
    const {name, value} = event.target
    const {data} = this.state
    data[name] = value
    this.setState({data})
  }

  toggleEditUser = () => {
    this.setState({
      showEditUser: !this.state.showEditUser
    })
  }

  render() {
    const {isLoading, data, pageData, totalPage, showEditUser, userSelected} = this.state
    return (
      <Segment loading={isLoading}>
        <Form>
          <Form.Group inline={true}>
            <Form.Field
              control={'input'}
              label={'Username'}
              name={'username'}
              onChange={this.onDataChange}
              type={'text'}
            />
            <Form.Field
              control={'input'}
              label={'Email'}
              name={'email'}
              onChange={this.onDataChange}
              type={'text'}
            />
          </Form.Group>
          <Form.Group inline={true}>
            <Form.Field control={'select'} label={'Sắp xếp theo'} onChange={this.onDataChange} name={'sortColumn'}>
              <option value={undefined}/>
              <option value={'createdAt'}>Ngày đăng ký</option>
              <option value={'amount'}>Số tiền hiện tại</option>
              <option value={'totalDep'}>Tiền đổi thưởng</option>
            </Form.Field>
          </Form.Group>
          <Button type={'submit'} onClick={() => this.searchUser(data)}>Search</Button>
        </Form>
        <Table>
          {this.renderHeader()}
          {this.renderBody(pageData)}
        </Table>
        <Pagination
          totalPages={totalPage}
          activePage={data.page + 1}
          onPageChange={this.handlePageChange}
        />
        {userSelected &&
        <Modal isOpen={showEditUser} toggle={this.toggleEditUser}>
          <ModalHeader>Chỉnh sửa người dùng</ModalHeader>
          <ModalBody>
            <EditUser user={userSelected}/>
          </ModalBody>
        </Modal>}
      </Segment>
    )
  }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/modules/HomeRoll/modules/Admin/modules/User/UserManagement.tsx